export const API_ENDPOINTS = {
  // Auth
  LOGIN: '/admin/auth/login',
  
  // Admin Dashboard
  DASHBOARD_COUNTS: '/admin/dashboard-counts',
  VISITOR_STATS: '/admin/visitor-stats',
  APPLICANT_STATS: '/admin/applicant-stats',
  
  // Jobs
  JOBS: '/jobs',
  JOB_DETAIL: (id) => `/jobs/${id}`,
  JOB_APPLICATIONS: '/jobs/applications',
  
  // Contents
  CONTENTS: '/contents',
  CONTENT_DETAIL: (id) => `/contents/${id}`,
  CONTENT_POPUP: (category) => `/contents/popup/${category}`,
  
  // Notices
  NOTICES: '/notices',
  NOTICE_DETAIL: (id) => `/notices/${id}`,
  
  // Visitors
  VISITORS: '/visitors',
  VISITOR_LIST: '/admin/visitor-list',
  
  // Applicants
  APPLICANT_LIST: '/admin/job-applications',  
  APPLICANT_SEARCH: '/admin/applicant-search',
  JOB_APPLICATIONS: '/jobs/applications',
  
  // Files
  UPLOAD_FILE: '/files/upload',
  
  // System
  SYSTEM_STATS: '/admin/system/stats',
  SYSTEM_STATUS: '/admin/system/status',
  SYSTEM_LOGS: '/admin/system/logs',
  SYSTEM_BACKUPS: '/admin/system/backups',
  SYSTEM_BACKUP_STATS: '/admin/system/backup/stats',
  
  // 방문자 관련 엔드포인트 수정
  VISITOR_RECORD: '/visitor',  
}; 